import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/outfit';
import App from './App';
import { AuthProvider } from './auth/AuthContext';
import { AppErrorBoundary } from './components/AppErrorBoundary';
import { SiteCopyProvider } from './content/SiteCopyContext';
import { SiteAssetsProvider } from './content/SiteAssetsContext';
import { ExperienceProvider } from './content/ExperienceContext';
import './styles.css';
import './taste-system.css';

const canonical = document.createElement('link');
canonical.rel = 'canonical';
canonical.href = `${window.location.origin}/`;
document.head.append(canonical);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppErrorBoundary><ExperienceProvider><SiteCopyProvider><SiteAssetsProvider><AuthProvider><App /></AuthProvider></SiteAssetsProvider></SiteCopyProvider></ExperienceProvider></AppErrorBoundary>
  </StrictMode>
);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' }).then((registration) => registration.update()).catch(() => undefined));
}
